<h1 mat-dialog-title>同行车友</h1>

<mat-dialog-content>
  <mat-list>
    <mat-list-item *ngFor="let busSeat of busSeats; let i = index" matRipple>
      <mat-label>{{ i + 1 }}</mat-label>

      <app-user-avatar
        [fileid]="busSeat?.user?.avatar"
        size="50px"
      ></app-user-avatar>
      <div class="info">
        <h2>{{ busSeat?.user?.nickname || "(空)" }}</h2>
        <span>{{ dateDiff(busSeat?.started_time) }}</span>
      </div>
    </mat-list-item>
  </mat-list>
</mat-dialog-content>

<mat-dialog-actions>
  <div style="flex: 1"></div>
  <button mat-button mat-dialog-close>关闭</button>
</mat-dialog-actions>
